<template>
    <div class="mt-7">
        <base-header class="pb-6" type="">
            <div class="d-flex justify-content-between align-items-center mb-2 mr-5">
                <div class="d-flex gap-2">
                    <span class="badge px-3 py-1 enabled-action"
                        :class="assetFilter === 'ALL' ? 'bg-primary text-white' : 'bg-light text-dark border'"
                        @click="setAssetFilter('ALL')">
                        All
                    </span>
                    <span class="badge px-3 py-1 enabled-action"
                        :class="assetFilter === 'COMMODITY' ? 'bg-primary text-white' : 'bg-light text-dark border'"
                        @click="setAssetFilter('COMMODITY')">
                        Commodity
                    </span>
                    <span class="badge px-3 py-1 enabled-action"
                        :class="assetFilter === 'INDEX' ? 'bg-primary text-white' : 'bg-light text-dark border'"
                        @click="setAssetFilter('INDEX')">
                        Index
                    </span>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <span class="text-muted small mr-3">Sort by:</span>
                    <span class="badge px-3 py-1 enabled-action"
                        :class="sortKey === 'capital' ? 'bg-primary text-white' : 'bg-light text-dark border'"
                        @click="setCapitalSort">
                        <i class="fas fa-wallet me-1"></i> Capital
                    </span>
                    <span class="badge px-3 py-1 enabled-action"
                        :class="sortKey === 'pnl' ? 'bg-primary text-white' : 'bg-light text-dark border'"
                        @click="toggleSort('pnl')">
                        <i class="fas fa-chart-line me-1"></i> PnL
                        <i v-if="sortKey === 'pnl'"
                            :class="sortOrder === 'asc' ? 'fas fa-arrow-up ml-1' : 'fas fa-arrow-down ml-1'">
                        </i>
                    </span>
                    <span class="badge px-3 py-1 enabled-action"
                        :class="sortKey === 'name' ? 'bg-primary text-white' : 'bg-light text-dark border'"
                        @click="toggleSort('name')">
                        <i class="fas fa-user me-1"></i> UserName
                    </span>
                </div>
            </div>
            <div v-for="(userGroup, groupIndex) in UserCount" :key="groupIndex" class="row">
                <div v-for="(userOption, userIndex) in userGroup" :key="userIndex"
                    class="col-xl-1 col-md-6 col-middle bg-light border border-light">
                    <div class="row align-items-center justify-content-center mt--1"
                        @click="goToPositionDetails(userOption.key)">
                        <h6 class="h3 mb-0 text-uppercase font-middle truncate-name enabled-action"
                            :title="getUserName(userOption.key)">
                            {{ truncateName(getUserName(userOption.key)) }}
                        </h6>
                    </div>
                    <div class="row">
                        <div class="col-6 border bg-portfolio-pnl d-flex align-items-center justify-content-center">
                            <h3 class="text-dark middle-h4 mb-0">
                                {{ userDataMap[userOption.key]?.exchangeTokens?.length || 0 }}
                            </h3>
                        </div>
                        <div
                            class="col-3 bg-positions-count text-dark d-flex justify-content-center align-items-center">
                            {{ userDataMap[userOption.key]?.entryPortfolios?.length || 0 }}
                        </div>
                        <div class="col-3 text-dark d-flex bg-entry-count justify-content-center align-items-center">
                            {{ userDataMap[userOption.key]?.exitPortfolios?.length || 0 }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 border bg-portfolio-pnl d-flex align-items-center justify-content-center">
                            <h3 class="mb-0"
                                :class="{ 'text-green': userAnalyticsMap[userOption.key]?.pnlPercentage > 0, 'text-danger': userAnalyticsMap[userOption.key]?.pnlPercentage < 0 }">
                                {{ userAnalyticsMap[userOption.key]?.pnlPercentage || '0.00' }}
                            </h3>
                        </div>
                        <div class="col-3 border bg-warning-chat text-dark d-flex align-items-center justify-content-center"
                            :class="userDataMap[userOption.key]?.latestExecutedTime ? 'bg-warning-chat' : 'bg-portfolio-pnl'">
                            {{ userDataMap[userOption.key]?.incompleteExitCount || 0 }}
                        </div>
                        <div class="col-5 border bg-warning-chat text-dark d-flex align-items-center justify-content-center"
                            :class="userDataMap[userOption.key]?.latestExecutedTime ? 'bg-warning-chat' : 'bg-portfolio-pnl'">
                            {{ userDataMap[userOption.key]?.latestExecutedTime || '-' }}
                        </div>
                    </div>
                </div>
            </div>
        </base-header>
    </div>
</template>
<script>
import moment from "moment";
export default {
    data() {
        return {
            selectOptions: [],
            selectedUsers: [],
            analyticsData: [],
            sortKey: 'capital',
            sortOrder: 'asc',
            assetFilter: 'ALL'
        };
    },
    mounted() {
        this.getActiveUsers();
    },
    computed: {
        UserCount() {
            const CountSize = 12;
            let sortedUsers = [...this.analyticsData];
            if (this.sortKey === 'capital') {
                sortedUsers.sort((a, b) => (b.capital || 0) - (a.capital || 0));
            } else if (this.sortKey === 'pnl') {
                const getPnLPercent = user => {
                    const positions = this.getFilteredPositions(user);
                    if (!positions.length || user.capital === 0) return 0;
                    const totalPnl = positions.reduce((sum, p) => sum + (p.pnl || 0), 0);
                    return totalPnl / user.capital;
                };
                sortedUsers.sort((a, b) =>
                    this.sortOrder === 'asc'
                        ? getPnLPercent(a) - getPnLPercent(b)
                        : getPnLPercent(b) - getPnLPercent(a)
                );
            } else if (this.sortKey === 'name') {
                sortedUsers.sort((a, b) => {
                    const nameA = this.getUserName(a.userId).toLowerCase();
                    const nameB = this.getUserName(b.userId).toLowerCase();
                    return this.sortOrder === 'asc'
                        ? nameA.localeCompare(nameB)
                        : nameB.localeCompare(nameA);
                });
            }
            const sortedSelectOptions = sortedUsers.map(user =>
                this.selectOptions.find(option => option.key === user.userId) || {}
            );
            const result = [];
            for (let i = 0; i < sortedSelectOptions.length; i += CountSize) {
                result.push(sortedSelectOptions.slice(i, i + CountSize));
            }
            return result;
        },
        userAnalyticsMap() {
            const result = {};
            this.analyticsData.forEach(user => {
                let totalPnl = 0;
                const positions = this.getFilteredPositions(user);
                positions.forEach(position => {
                    totalPnl += position.pnl || 0;
                });
                const capital = user.capital || 0;
                const pnlPercentage = capital !== 0 && isFinite(totalPnl / capital)
                    ? ((totalPnl / capital) * 100).toFixed(2)
                    : "0.00";
                result[user.userId] = { pnlPercentage };
            });
            return result;
        },
        userDataMap() {
            return this.analyticsData.reduce((map, user) => {
                const entrySet = new Set();
                const exitSet = new Set();
                const exchangeTokenSet = new Set();
                let incompleteExitCount = 0;
                let latestExecutedTime = null;
                user.orderBeans?.forEach(order => {
                    if (!order.portfolioName) return;
                    if (order.status === 'OPEN') {
                        entrySet.add(order.portfolioName);
                        order.entryOrders?.forEach(entry => {
                            const uniqueKey = `${entry.exchangeToken}_${order.tradeTermId}`;
                            exchangeTokenSet.add(uniqueKey);
                        });
                    } else if (order.status === 'CLOSED') {
                        exitSet.add(order.portfolioName);
                        order.exitOrders?.forEach(exit => {
                            if (exit.executedStatus && exit.executedStatus !== "COMPLETE") {
                                incompleteExitCount++;
                                if (exit.executedDateTime) {
                                    let cleanTime = exit.executedDateTime.split(".")[0];
                                    const exitMoment = moment(cleanTime);
                                    if (!latestExecutedTime || exitMoment.isAfter(latestExecutedTime)) {
                                        latestExecutedTime = exitMoment;
                                    }
                                }
                            }
                        });
                    }
                });
                if (latestExecutedTime) {
                    latestExecutedTime = latestExecutedTime.format("HH:mm");
                }
                map[user.userId] = {
                    ...user,
                    entryPortfolios: Array.from(entrySet),
                    exitPortfolios: Array.from(exitSet),
                    exchangeTokens: Array.from(exchangeTokenSet),
                    incompleteExitCount,
                    latestExecutedTime
                };
                return map;
            }, {});
        }
    },
    methods: {
        setAssetFilter(type) {
            this.assetFilter = type;
        },
        getFilteredPositions(user) {
            const positions = user.positionBeans || [];
            if (this.assetFilter === 'ALL') return positions;
            return positions.filter(p => p.assetName === this.assetFilter);
        },
        goToPositionDetails(userKey) {
            sessionStorage.setItem('positionUser', JSON.stringify({
                key: userKey,
                name: this.getUserName(userKey),
                assetFilter: this.assetFilter
            }));
            this.$router.push({ name: 'PositionDetails' });
        },
        setCapitalSort() {
            this.sortKey = 'capital';
            this.sortOrder = 'desc';
        },
        toggleSort(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortOrder = 'asc';
            }
        },
        getActiveUsers() {
            let data = { type: 'active-users' };
            if (sessionStorage.getItem(data.type + "-reference-data")) {
                this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"));
                this.selectedUserIds = this.selectOptions.map(user => user.key);
                this.getAnalyticsData();
            } else {
                this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
                    .then(response => {
                        this.selectOptions = response.server.data;
                        sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(this.selectOptions));
                        this.selectedUserIds = response.server.data.map(user => user.key);
                        this.getAnalyticsData();
                    });
            }
        },
        getAnalyticsData() {
            let data = { userIds: this.selectedUserIds };
            this.$store.dispatch("analyticsDashboard/getAnalyticsData", data, { root: true })
                .then(response => {
                    this.analyticsData = response.server.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getUserName(userId) {
            let user = this.selectOptions.find(option => option.key === userId);
            return user ? user.value : "";
        },
        truncateName(name) {
            const maxLength = 20;
            return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
        }
    }
};
</script>
